import type { EvidenceItem } from "@/types";

const weightStyle: Record<string, string> = {
  高: "bg-primary-100 text-primary-700 border-primary-200",
  中: "bg-accent-100 text-accent-800 border-accent-200",
  低: "bg-background-200 text-foreground-600 border-background-300",
};

export default function EvidenceChain({ evidence }: { evidence: EvidenceItem[] }) {
  return (
    <ol className="space-y-4">
      {evidence.map((item, index) => (
        <li
          key={item.id}
          className="relative border border-background-200 rounded-card bg-background-50 p-5"
        >
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-mono-num text-[11px] text-foreground-400">
              E{String(index + 1).padStart(2, "0")}
            </span>
            <span className="px-2 py-0.5 rounded-control bg-secondary-100 text-secondary-800 text-[11px]">
              {item.type}
            </span>
            <span
              className={`px-2 py-0.5 rounded-control border text-[11px] ${weightStyle[item.weight]}`}
            >
              证据权重 · {item.weight}
            </span>
          </div>
          <h4 className="mt-3 font-heading text-base font-bold text-foreground-950 leading-snug">
            {item.title}
          </h4>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.detail}</p>
        </li>
      ))}
    </ol>
  );
}